export default __webpack_public_path__ + "static/media/Rahul.175c7779.jpeg";